import { useRef, useState, useEffect, useCallback } from "react";

import { LOCAL_STORAGE_NUMBERS_FILTERS_DIALER } from "const";


export const useNumbersFilters = ({
    perPage,
    service,
    tableRef,
    activeTrunkId,
    defaultFilter,
    currentPerPage,
    currentDisplay,

    setSelectedItems,
    getTrunkNumbersList
}) => {
    const savedTableFilter = JSON.parse(localStorage.getItem(LOCAL_STORAGE_NUMBERS_FILTERS_DIALER));
    const initialFilter = savedTableFilter && Object.keys(savedTableFilter).length
        ? savedTableFilter
        : defaultFilter;

    const [filter, setFilter] = useState(initialFilter);
    const [activeFiltersCount, setActiveFiltersCount] = useState(0);

    useEffect(() => {
        onSetActiveFiltersCount(initialFilter);
    }, []);

    const stateRef = useRef({
        activeTrunkId,
        service,
        currentDisplay,
        currentPerPage,
        perPage,
        defaultFilter,
        getTrunkNumbersList,
        setSelectedItems,
        tableRef
    });

    stateRef.current = {
        activeTrunkId,
        service,
        currentDisplay,
        currentPerPage,
        perPage,
        defaultFilter,
        getTrunkNumbersList,
        setSelectedItems,
        tableRef
    };

    const onChangeFilters = useCallback((filtersValue) => {
        const {
            activeTrunkId,
            service,
            currentDisplay,
            currentPerPage,
            perPage,
            defaultFilter,
            getTrunkNumbersList,
            setSelectedItems,
            tableRef
        } = stateRef.current;

        onSetActiveFiltersCount(filtersValue);
        setFilter(filtersValue);

        localStorage.setItem(LOCAL_STORAGE_NUMBERS_FILTERS_DIALER, JSON.stringify(filtersValue));

        if (activeTrunkId) {
            const pickedPerPage = currentPerPage || perPage;
            const pickedFilter = filtersValue || defaultFilter;
            const startPage = 1;

            getTrunkNumbersList(
                activeTrunkId,
                service,
                pickedPerPage,
                pickedFilter,
                startPage,
                currentDisplay
            );
        }

        setSelectedItems(new Map());
        tableRef.current.clear();
    }, []);

    const onSetActiveFiltersCount = useCallback((value) => {
        if (!value)
            return;

        const filterKeysList = Object.keys(value);
        const activeFilters = filterKeysList.filter(key => {
            if (value[key] === defaultFilter[key] || (!value[key] && value[key] !== 0)) {
                return false;
            }

            return true;
        });

        setActiveFiltersCount(activeFilters.length);
    }, [defaultFilter]);

    return {
        filter,
        activeFiltersCount,

        setFilter,
        onChangeFilters,
        onSetActiveFiltersCount
    };
};
